<template>
  <div>
    <section class="hero">
        <div class="hero-container">
            <div class="hero-content">
                <span v-html="heroTitle"></span>
                <div class="hero-title2">{{$t('hero.title2')}}</div>
                <p v-if="!isMobile">{{$t('hero.subtitle')}}</p>
                <p v-else v-html="$t('hero.subtitle1')"></p>
                <div class="stats">
                    <div class="stat">
                        <img class="stat-img" src="@/assets/images/order.png">
                        <div>
                        <div class="stat-number">{{$t('stats.orders_number')}}</div>
                            <div class="stat-text">{{$t('stats.orders')}}</div>
                    </div>
                    </div>
                    <div style="width: 60px;"></div>
                    <div class="stat">
                        <img class="stat-img" src="@/assets//images/order-daily.png">
                        <div>
                            <div class="stat-number">{{$t('stats.daily_number')}}</div>
                            <div class="stat-text">{{$t('stats.daily')}}</div>
                    </div>
                </div>
                </div>
            </div>
            <a :href="isMobile ? 'https://mclient.erlianpartner.com' : 'https://client.erlianpartner.com'" class="hero-register-button" target="_blank">{{$t('button.register')}}</a>
            <div class="hero-image"></div>
        </div>
    </section>
    <!-- 奇瑞 -->
    <section class="section">
        <div class="container">
            <!-- pc端 -->
            <div class="qirui-pc-iframe" v-if="!isMobile">
              <!-- <div class="qirui-bg"></div> -->
               <img src="@/assets/images/qirui/bg-pc.png" class="qirui-pc-bg">
               <div class="qirui-pc-content">
                  <div class="qirui-pc-title" v-html="$t('qirui.title')"></div>
                  <div class="qirui-pc-con" v-html="$t('qirui.cont')"></div>
                  <button class="btn-default qirui-pc-btn" @click="goqirui">{{$t('qirui.button')}}</button>
               </div>
            </div>
            <!-- 移动端 -->
            <div class="qirui-mobile-iframe" v-else>
              <!-- <div class="qirui-bg"></div> -->
               <img src="@/assets/images/qirui/bg.png" class="qirui-mobile-bg">
               <div class="qirui-mobile-content">
                  <div class="qirui-mobile-title">{{ $t('qirui.title1') }}</div>
                  <div class="qirui-mobile-con" v-html="$t('qirui.cont1')"></div>
                  <button class="qirui-mobile-btn" @click="goqirui">{{$t('qirui.button')}}</button>
               </div>
            </div>
        </div>
    </section>

    <!-- Product Showcase -->
    <section class="section">
        <div class="container">
            <h2 class="section-title" v-html="productTitle"></h2>
            <p class="section-subtitle">{{$t('product.subtitle')}}</p>
            <!-- <div v-if="!isMobile"> -->
                <!-- 新的轮播组件 -->
            <div class="product-carousel-container">
                <div class="carousel-wrapper">
                    <div class="carousel-track" :style="{ transform: `translateX(-${currentIndex * itemWidth}%)` }">
                        <div 
                            v-for="(image, index) in displayImages" 
                            :key="index"
                            class="carousel-item"
                            :class="{ 
                                'active': isCenterImage(index),
                                'left': isLeftImage(index),
                                'right': isRightImage(index)
                            }"
                            @click="goToImage(index)"
                        >
                            <div class="carousel-image-wrapper">
                                <img 
                                    :src="image" 
                                    :alt="`产品图片 ${getImageNumber(index)}`"
                                    class="carousel-image"
                                />
                            </div>
                        </div>
                    </div>
                    
                    <!-- 导航按钮 -->
                    <button class="carousel-nav carousel-prev" @click="prevSlide">
                        <span>‹</span>
                    </button>
                    <button class="carousel-nav carousel-next" @click="nextSlide">
                        <span>›</span>
                    </button>
                </div>
                
                <!-- 30个指示点 -->
                <div class="carousel-indicators">
                    <div 
                        v-for="index in totalImages" 
                        :key="index"
                        class="indicator"
                        :class="{ active: currentImageNumber === index }"
                        @click="goToImageByNumber(index)"
                    ></div>
                </div>
            </div>
        </div>
    </section>

    <!-- Delivery Section -->
    <!-- <section class="section" id="delivery">
         <div class="delivery-scontent">
            <img :src="deliveryImage" mode="widthFix">
            <div class="delivery-stitle" v-html="$t('delivery.title')"></div>
            <div class="delivery-name" v-html="$t('delivery.title1')"></div>

         </div>
    </section> -->

    <!-- Operation Flow -->
    <!-- <section class="section">
        <div class="container">
            <h2 class="section-title" v-html="$t('flow.title')"></h2>
            <p class="section-subtitle" v-if="!isMobile">{{$t('flow.subtitle')}}</p>
            <p class="section-subtitle" v-else v-html="$t('flow.subtitle1')"></p>

            <div class="flow-steps">
                <div class="flow-step">
                    <div class="step-title" v-if="!isMobile">{{$t('flow.step1')}}</div>
                    <div class="step-icon"><img src="@/assets//images/step1.png" class="step-icon-img" :alt="$t('flow.step1.text')"></div>
                    <div class="step-content">
                    <div class="step-title" v-if="isMobile">{{$t('flow.step1')}}</div>
                    <p class="step-title-text">{{$t('flow.step1.text')}}</p>
                </div>
                </div>
                <div class="flow-arrow mobile-only"></div>
                <div class="flow-step">
                    <div class="step-title" v-if="!isMobile">{{$t('flow.step2')}}</div>
                    <div class="step-icon"><img src="@/assets//images/step2.png" class="step-icon-img" :alt="$t('flow.step2.text')"></div>
                    <div class="step-content">
                    <div class="step-title" v-if="isMobile">{{$t('flow.step2')}}</div>
                    <p class="step-title-text">{{$t('flow.step2.text')}}</p>
                </div>
                </div>
                <div class="flow-arrow mobile-only"></div>
                <div class="flow-step">
                    <div class="step-title" v-if="!isMobile">{{$t('flow.step3')}}</div>
                    <div class="step-icon"><img src="@/assets//images/step3.png" class="step-icon-img" :alt="$t('flow.step3.text')"></div>
                    <div class="step-content">
                    <div class="step-title" v-if="isMobile">{{$t('flow.step3')}}</div>
                    <p class="step-title-text">{{$t('flow.step3.text')}}</p>
                </div>
                </div>
                <div class="flow-arrow mobile-only"></div>
                <div class="flow-step">
                    <div class="step-title" v-if="!isMobile">{{$t('flow.step4')}}</div>
                    <div class="step-icon"><img src="@/assets//images/step4.png" class="step-icon-img" :alt="$t('flow.step4.text')"></div>
                    <div class="step-content">
                    <div class="step-title" v-if="isMobile">{{$t('flow.step4')}}</div>
                    <p class="step-title-text">{{$t('flow.step4.text')}}</p>
                </div>
                </div>
                <div class="flow-arrow mobile-only"></div>
                <div class="flow-step">
                    <div class="step-title" v-if="!isMobile">{{$t('flow.step5')}}</div>
                    <div class="step-icon"><img src="@/assets//images/step5.png" class="step-icon-img" :alt="$t('flow.step5.text')"></div>
                    <div class="step-content">
                    <div class="step-title" v-if="isMobile">{{$t('flow.step5')}}</div>
                    <p class="step-title-text">{{$t('flow.step5.text')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </section> -->

    <!-- Platform Integration -->
    <section class="section">
        <div class="container">
            <h2 class="platform-section-title" v-html="$t('platform.title')"></h2>
            <div class="platform-content">
                <div>
                    <div>
                        <p class="platform-section-subtitle">{{$t('platform.subtitle')}}</p>
                    </div>

                    <div class="platform-buttons">
                        <a :href="isMobile ? 'https://mclient.erlianpartner.com' : 'https://client.erlianpartner.com'" class="btn-primary-1">{{$t('platform.connect')}}</a>
                        <button class="btn-default">{{$t('platform.create')}}</button>
                    </div>
                </div>
                <div class="platform-logos">
                    <div class="platform-logo">
                        <img src="@/assets//images/shopify.png" alt="Shopify" class="platform-logo-img">
                </div>
                    <div class="platform-logo">
                        <img src="@/assets//images/wix.com.png" alt="Wix.com" class="platform-logo-img">
                    </div>
                    <div class="platform-logo">
                        <img src="@/assets//images/bigcommerce.png" alt="BigCommerce" class="platform-logo-img">
                    </div>
                    <div class="platform-logo">
                        <img src="@/assets//images/ebay.png" alt="eBay" class="platform-logo-img">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- You Sell We Supply -->
    <section class="section">
        <div class="container-2">
            <h2 class="section-title" v-html="$t('image.title')"></h2>


        </div>
    </section>
     <!-- 移动端单独图片 -->
     <div class="mobile-image-single">
        <img src="@/assets//images/image-grid.png" :alt="$t('product.title')" class="mobile-single-img">
    </div>
    <div class="image-grid-container">
        <div class="image-grid">
                <!-- 第一行 -->
                <div class="image-row">
                    <img class="image-grid-img" src="@/assets//images/show-1.png" />
                    <img class="image-grid-img" src="@/assets//images/show-2.png" />
                    <img class="image-grid-img" src="@/assets//images/show-3.png" />
                    <img class="image-grid-img" src="@/assets//images/show-4.png" />
                    <img class="image-grid-img" src="@/assets//images/show-5.png" />
                    <img class="image-grid-img" src="@/assets//images/show-6.png" />
                    <!-- 重复图片以实现无缝滚动 -->
                    <img class="image-grid-img" src="@/assets//images/show-1.png" />
                    <img class="image-grid-img" src="@/assets//images/show-2.png" />
                    <img class="image-grid-img" src="@/assets//images/show-3.png" />
                    <img class="image-grid-img" src="@/assets//images/show-4.png" />
                    <img class="image-grid-img" src="@/assets//images/show-5.png" />
                    <img class="image-grid-img" src="@/assets//images/show-6.png" />
                </div>
                <!-- 第二行 -->
                <div class="image-row">
                    <img class="image-grid-img" src="@/assets/images/show-7.png" />
                    <img class="image-grid-img" src="@/assets/images/show-8.png" />
                    <img class="image-grid-img" src="@/assets/images/show-9.png" />
                    <img class="image-grid-img" src="@/assets/images/show-10.png" />
                    <img class="image-grid-img" src="@/assets/images/show-11.png" />
                    <img class="image-grid-img" src="@/assets/images/show-12.png" />
                    <!-- 重复图片以实现无缝滚动 -->
                    <img class="image-grid-img" src="@/assets/images/show-7.png" />
                    <img class="image-grid-img" src="@/assets/images/show-8.png" />
                    <img class="image-grid-img" src="@/assets/images/show-9.png" />
                    <img class="image-grid-img" src="@/assets/images/show-10.png" />
                    <img class="image-grid-img" src="@/assets/images/show-11.png" />
                    <img class="image-grid-img" src="@/assets/images/show-12.png" />
                </div>
            </div>
        </div>

    <!-- Company Introduction -->
    <section class="section">
        <div class="container">
            <h2 class="section-title" v-html="$t('company.title')"></h2>
            <div class="section-subtitle gywm-subtitle">
                <p v-html="$t('company.description')"></p>
            </div>
        </div>
    </section>


    <!-- <section class="section" v-if="currentLanguage != 'cn'">
        <div class="container">
            <h2 class="section-title" v-html="$t('logistics.title')"></h2>
        </div>
    </section> -->
    <div v-if="currentLanguage == 'cn'" style="margin-top: 2rem;width: 100%;height: 1px;"></div>
    <img class="global-map" :src="globalMapImage"/>

    <!-- Core Advantages -->
    <section class="section">
        <div class="container">
            <h2 class="section-title" v-html="$t('advantages.title')"></h2>
            <div class="core-advantages">
                <p class="section-subtitle flow-subtitle" v-html="$t('advantages.subtitle')"></p>
            </div>

            <!-- 跳转中行边贸通 -->
            <div class="gotoWeb">
                <img class="gotoWeb-icon" src="@/assets/images/gotoLogo.png" mode="heightFix"/>
                <div class="gotoWeb-tip" @click="gotoBianMiao">{{ $t('advantages.apply') }} <img style="margin: 3px 0 0 9px;" src="@/assets/images/arraw.png" /></div>
            </div>

            <div class="core-advantages">
                <p class="section-subtitle flow-subtitle" v-html="$t('advantages.subtitle1')"></p>
            </div>

            <!-- <div class="advantages-grid">
                <div class="advantage-card advantage-item">
                    <div class="advantage-content">
                        <div class="advantage-icon-content">
                            <img class="advantage-icon-img" src="@/assets//images/Advantages-1.png">
                            <span class="advantage-icon-title">{{$t('advantage1.title')}}</span>
                </div>
                        <div class="advantage-icon-text">{{$t('advantage1.description')}}</div>
                </div>
                </div>

                <div class="advantage-card advantage-item">
                    <div class="advantage-content">
                        <div class="advantage-icon-content">
                            <img class="advantage-icon-img" src="@/assets//images/Advantages-2.png">
                            <span class="advantage-icon-title">{{$t('advantage2.title')}}</span>
                        </div>
                        <div class="advantage-icon-text">{{$t('advantage2.description')}}</div>
                    </div>
                </div>
                <div class="advantage-card advantage-item">
                    <div class="advantage-content">
                        <div class="advantage-icon-content">
                            <img class="advantage-icon-img" src="@/assets//images/Advantages-3.png">
                            <span class="advantage-icon-title">{{$t('advantage3.title')}}</span>
                        </div>
                        <div class="advantage-icon-text">{{$t('advantage3.description')}}</div>
                    </div>
                </div>

                <div class="advantage-card advantage-item">
                    <div class="advantage-content">
                        <div class="advantage-icon-content">
                            <img class="advantage-icon-img" src="@/assets//images/Advantages-4.png">
                            <span class="advantage-icon-title">{{$t('advantage4.title')}}</span>
                        </div>
                        <div class="advantage-icon-text">{{$t('advantage4.description')}}</div>
                    </div>
                </div>
            </div> -->
        </div>
    </section>

    <!-- News Section -->
    <!-- <section class="section">
        <div class="container">
            <h2 class="section-title" data-lang="news.title">新闻</h2>

            <div class="news-grid">
                <div class="news-card news-item">
                    <img src="@/assets//images/news1.png" class="news-image" />
                     <div class="news-image">会议场景</div>
                    <div class="news-content">
                        <h3 class="news-title" data-lang="news1.title">全新物流方案正式上线</h3>
                        <p class="news-date" data-lang="news1.date">2025-09-03</p>
                    </div>
                </div>
                <div class="news-card news-item">
                    <img src="@/assets//images/news2.png" class="news-image" />
                    <div class="news-content">
                        <h3 class="news-title" data-lang="news2.title">时尚选品和采购配送助理</h3>
                        <p class="news-date" data-lang="news2.date">2025-09-09</p>
                    </div>
                </div>
                <div class="news-card news-item">
                    <img src="@/assets//images/news3.png" class="news-image" />
                    <div class="news-content">
                        <h3 class="news-title" data-lang="news3.title">热门商品目录推荐</h3>
                        <p class="news-date" data-lang="news3.date">2025-09-10</p>
                    </div>
                </div>
            </div>
        </div>
    </section> -->

    <!-- Final CTA -->
    <section class="final-cta advantage-card" :style="!isMobile ? 'margin-top: 2rem' : ''">
        <div class="cta-left-content">
            <h2 class="cta-title-text" v-html="$t('cta.title')"></h2>
            <a :href="isMobile ? 'https://mclient.erlianpartner.com' : 'https://client.erlianpartner.com'" class="cta-button">{{$t('cta.button')}}</a>
                </div>
        <div class="cta-right-content">
            <div class="cta-right-content-item"><img class="cta-right-content-item-img"
                    src="@/assets/images/right-img.png"><span>{{$t('cta.feature1')}}</span></div>
            <div class="cta-right-content-item"><img class="cta-right-content-item-img"
                    src="@/assets/images/right-img.png"><span>{{$t('cta.feature2')}}</span></div>
            <div class="cta-right-content-item"><img class="cta-right-content-item-img"
                    src="@/assets/images/right-img.png"><span>{{$t('cta.feature3')}}</span></div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
    //   productImages: [
    //     require('@/assets/images/product-1.png'),
    //     require('@/assets/images/product-2.png'),
    //     require('@/assets/images/product-3.png'),
    //     require('@/assets/images/product-4.png'),
    //     require('@/assets/images/product-5.png')
    //   ],
      productImages: [],
      currentIndex: 0,
      autoSlideInterval: null,
      isMobile: window.innerWidth <= 1024,

      // 新增轮播相关数据
      itemsPerView: 5, // 默认显示5张图片
      itemWidth: 20, // 每张图片宽度百分比
      totalImages: 30,
      itemImg: require('@/assets/images/item.png')
    }
  },
  computed: {
    // 动态生成全球地图图片路径
    globalMapImage() {
      const isMobile = window.innerWidth <= 1024
      const language = 'cn'
      if (isMobile) {
        return require(`@/assets/images/map_${language}.png`)
      } else {
        return require(`@/assets/images/map_pc_${language}.png`)
      }
    },

    // 获取当前语言
    currentLanguage() {
      return this.$store.state.currentLanguage
    },

    // 动态生成配送图片路径
    deliveryImage() {
      const isMobile = window.innerWidth <= 1024
      console.log(this.currentLanguage,'this.currentLanguage');
      
      if (isMobile) {
        return require(`@/assets/images/ditu/mobile-${this.currentLanguage}.jpg`)
      } else {
        return require(`@/assets/images/ditu/pc-${this.currentLanguage}.jpg`)
      }
    },
    
    heroTitle() {
        return this.$store.getters.currentTranslations[
            !this.isMobile || this.currentLanguage === 'en' ? 'hero.title' : 'hero.title1'
        ]
    },
    
    productTitle() {
        return this.$store.getters.currentTranslations[
            !this.isMobile || this.currentLanguage === 'en' ? 'product.title' : 'product.title1'
        ]
    },
    
    // 新增轮播相关计算属性
    displayImages() {
      // 创建循环图片数组以实现无缝轮播
      const images = [];
      for (let i = 1; i <= this.totalImages; i++) {
        // 在实际项目中替换为您的图片路径
        images.push(require(`@/assets/images/productImg/product-${i}.jpg`));
      }
      return images;
    },
    
    centerIndex() {
      return Math.floor(this.itemsPerView / 2);
    },
    
    // 当前显示的图片编号（1-30）
    currentImageNumber() {
      return (this.currentIndex % this.totalImages) + 1;
    },
  },
  mounted() {
    this.initCarousel();
    window.addEventListener('resize', this.handleResize);
    this.generateProductImages();
  },
  beforeDestroy() {
    this.stopAutoSlide();
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 新增轮播方法
    generateProductImages() {
      this.productImages = [];
      for (let i = 1; i <= 30; i++) {
        this.productImages.push(require('@/assets/images/productImg/product-'+ i + '.jpg'));
      }
    },
    
    initCarousel() {
      this.updateItemsPerView();
      this.startAutoSlide();
    },
    
    updateItemsPerView() {
      const width = window.innerWidth;
      if (width < 768) {
        this.itemsPerView = 3; // 手机端显示3张
        this.itemWidth = 33.33;
      } else if (width < 1024) {
        this.itemsPerView = 4; // 平板端显示4张
        this.itemWidth = 25;
      } else {
        this.itemsPerView = 5; // 桌面端显示5张
        this.itemWidth = 20;
      }
    },
    
    // 判断是否为居中图片
    isCenterImage(index) {
    //   const visibleStartIndex = this.currentIndex;
    //   const visibleEndIndex = this.currentIndex + this.itemsPerView - 1;
      const centerOffset = Math.floor(this.itemsPerView / 2);
      const centerIndex = this.currentIndex + centerOffset;
      
      return index === centerIndex;
    },
    
    // 判断是否为左侧图片
    isLeftImage(index) {
      const visibleStartIndex = this.currentIndex;
      const centerOffset = Math.floor(this.itemsPerView / 2);
      const centerIndex = this.currentIndex + centerOffset;
      
      return index >= visibleStartIndex && index < centerIndex;
    },
    
    // 判断是否为右侧图片
    isRightImage(index) {
      const visibleEndIndex = this.currentIndex + this.itemsPerView - 1;
      const centerOffset = Math.floor(this.itemsPerView / 2);
      const centerIndex = this.currentIndex + centerOffset;
      
      return index > centerIndex && index <= visibleEndIndex;
    },
    
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.displayImages.length;
    },
    
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.displayImages.length) % this.displayImages.length;
    },
    
    goToImage(index) {
      this.currentIndex = index;
    },
    
    goToImageByNumber(imageNumber) {
      this.currentIndex = imageNumber - 1;
    },
    
    getImageNumber(index) {
      return (index % this.totalImages) + 1;
    },
    
    startAutoSlide() {
      this.stopAutoSlide();
      this.autoSlideInterval = setInterval(() => {
        this.nextSlide();
      }, 4000);
    },
    
    stopAutoSlide() {
      if (this.autoSlideInterval) {
        clearInterval(this.autoSlideInterval);
        this.autoSlideInterval = null;
      }
    },
    
    handleResize() {
      this.isMobile = window.innerWidth <= 1024;
      this.updateItemsPerView();
    },
    gotoBianMiao(){
        window.open('https://bmt-client.erlianpartner.com', '_blank');
    },
    goqirui(){
      if(!this.isMobile){
        this.$router.push('/chery');
      }else {
        this.$router.push('/chery-mobile');
      }
    }
  }
}
</script>

<style>
.btn-primary-1 {
    background: #64B800;
    color: white;
    padding: 0;
    border: none;
    font-weight: bold;
    width: 11.25rem;
    height: 3.12rem;
    line-height: 3.12rem;
    text-align: center;
    cursor: pointer;
    margin-top: 1rem;
    transition: background 0.3s;
    display: inline-block;
    vertical-align: middle;
    box-sizing: border-box;
    text-decoration: none;
    font-size: 1rem;
    border-radius: 4px;
}

 .btn-primary:hover {
     background: #64B800;
 }

 /* Language Selector */
 .language-selector {
     display: flex;
     align-items: center;
     gap: 0.5rem;
     margin-right: 1rem;
     position: relative;
 }

.language-icon {
    width: 20px;
    height: 20px;
    background: url('@/assets/images/language.png');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.language-dropdown-toggle {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
    background: none;
    border: 1px solid transparent;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #666;
    font-size: 0.9rem;
}

.language-dropdown-toggle:hover {
    background-color: rgba(100,184, 0, 0.1);
    color: #64B800;
}

.language-dropdown-icon {
    width: 0.6rem;
    height: 0.6rem;
    background-image: url("@/assets/images/arrow_down_brown.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transition: transform 0.3s ease;
    display: inline-block;
}

.language-dropdown:hover .language-dropdown-icon {
    transform: rotate(180deg);
}

.language-dropdown-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    padding: 0.5rem 0;
    min-width: 120px;
    opacity: 0;
    visibility: hidden;
    /* transform: translateY(-10px); */
    transition: all 0.3s ease;
    z-index: 1000;
}

.language-dropdown:hover .language-dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}


.language-dropdown-menu .language-option {
    display: block;
    padding: 0.75rem 1rem;
    color: #374151;
    text-decoration: none;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    border-radius: 0;
    transform: none;
}

.language-dropdown-menu .language-option:hover {
    background-color: rgba(100,184, 0, 0.1);
    color: #64B800;
    transform: none;
}

 .language-dropdown {
     position: relative;
     display: inline-block;
 }

.language-select {
    background: none;
    border: 1px solid transparent;
    padding: 0.25rem 0.5rem;
    font-size: 0.9rem;
    color: #666;
    cursor: pointer;
    border-radius: 6px;
    appearance: none;
    padding-right: 1.5rem;
    background-image: url("@/assets/images/arrow_down_brown.png");
    background-position: right 0.5rem center;
    background-repeat: no-repeat;
    background-size: 1rem;
    transition: all 0.3s ease;
}

 .language-select:hover {
     color: #64B800;
     border-color: #64B800;
     background-color: rgba(226, 67, 14, 0.05);
 }

 .language-select:focus {
     outline: none;
     color: #64B800;
     border-color: #64B800;
     background-color: rgba(100,184, 0, 0.1);
     box-shadow: 0 0 0 2px rgba(226, 67, 14, 0.2);
 }

/* 下拉选项样式 - PC端 */
.language-select option {
    background-color: #ffffff !important;
    color: #374151 !important;
    padding: 0.5rem 0.75rem !important;
    font-size: 0.95rem !important;
    font-weight: 500 !important;
    border: none !important;
    font-family: inherit !important;
}

 .language-select option:hover {
     background-color: rgba(100,184, 0, 0.1) !important;
     color: #64B800 !important;
 }

 .language-select option:checked {
     background-color: #64B800 !important;
     color: #ffffff !important;
     font-weight: 600 !important;
 }

/* 通用下拉选项样式 - 确保跨浏览器兼容 */
select.language-select option {
    background-color: #ffffff !important;
    color: #374151 !important;
    padding: 0.5rem 0.75rem !important;
    font-size: 0.95rem !important;
    font-weight: 500 !important;
    border: none !important;
    font-family: inherit !important;
}

 select.language-select option:hover {
     background-color: rgba(100,184, 0, 0.1) !important;
     color: #64B800 !important;
 }

 select.language-select option:checked {
     background-color: #64B800 !important;
     color: #ffffff !important;
     font-weight: 600 !important;
 }

 /* Hero Section */
.hero {
    background: linear-gradient(270deg, rgba(59, 30, 12, 0) 0%, rgba(57, 27, 12, 0.37) 42%, rgba(55, 22, 12, 0.49) 100%), url('@/assets/images/top_banner.jpg');
    background-size: cover;
    background-position: center;
    height: 43.75rem;
    width: 100%;
    display: flex;
    align-items: center;
    color: white;
    margin-top: 5rem;
}

.hero-container {
    /* position: absolute;
    left: 8rem; */
    width: 100%;
    padding: 0 2rem;
    /* display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 13rem; */
    text-align: center;
    margin: 2rem auto 0;
    align-items: center;
}

.hero-content {
    width: 100%;
}

.hero-content span {
    font-size: 2.5rem;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 1rem;
    line-height: 1.2;
}

.hero-content .pc-only {
    display: block;
}

.hero-content .mobile-only {
    display: none;
}

.hero-title2 {
    font-size: 1.9rem;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 1rem;
    line-height: 1.8
}

.hero-content p {
    font-size: 1.25rem;
    font-weight: normal;
    color: #FFFFFF;
    margin-top: 1rem;
    margin-bottom: 2rem;
    opacity: 0.8;
}

.stats {
    display: flex;
    justify-content: center;
    margin-top: 4rem;
    gap: 2rem;
    margin-bottom: 2rem;
}

.stat {
    display: flex;
    align-items: center;
}

.stat img {
    width: 54px;
    height: 56px;
    object-fit: contain;
}

.stat-text {
    font-size: 1rem;
    font-weight: normal;
    color: #64B800;
    white-space: wrap;

}

.stat>div {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.stat-number {
    font-size: 2rem;
    font-weight: bold;
    color: #FFFFFF;
    margin-bottom: 0.25rem;
}

.stat>div>div:last-child {
    font-size: 0.9rem;
    color: #FFFFFF;
    opacity: 0.8;
}

.hero-register-button {
    width: 13.2rem;
    color: #64B800;
    background: white;
    padding: 1rem 2rem;
    border: none;
    font-weight: bold;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.3s;
    text-decoration: none;
    display: inline-block;
    text-align: center;
    border-radius: 4px;
    margin-top: 1rem;
    order: 2;
}


 /* .hero-image {
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 300"><rect fill="%23ddd" width="400" height="300"/><text x="200" y="150" text-anchor="middle" fill="%23999">Hero Image</text></svg>');
            background-size: cover;
            height: 400px;
            border-radius: 10px;
        } */

/* Sections */
.section {
    margin-top: 8rem;
}

.container {
    max-width: 100rem;
    margin: 0 auto;
    padding: 0 2rem;
}

 .container-2 {
     /* max-width: 1200px; */
     margin: 0 auto;
     padding: 0 2rem;
 }

.section-title {
    text-align: center;
    font-size: 2rem;
    margin-bottom: 1rem;
    font-weight: bold;
    color: #000000;
}

.success-text {
    font-size: 2rem;
    font-weight: bold;
    color: #64B800
}

.success-text-2 {
    font-size: 2rem;
    font-weight: bold;
    color: #61D118
}

.section-subtitle {
    text-align: center;
    max-width: 80%;
    font-size: 1rem;
    font-weight: normal;
    color: #353534;
    margin: 0 auto;
}
.flow-subtitle{
    width: 50%;
    text-align: left;
}

/* Platform Section Specific Styles */
.platform-section-title {
    text-align: center;
    font-size: 1.8rem;
    font-weight: bold;
    color: #000000;
    margin-bottom: 2rem;
}

.platform-section-subtitle {
    max-width: 35rem;
    text-align: left;
    font-size: 1.1rem;
    font-weight: normal;
    color: #353534;
    text-indent: 2em;
}

 /* Product Showcase */
 .product-carousel {
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: center;
     margin: 3rem 0;
     height: 15rem;
     position: relative;
 }

 .carousel-container {
     display: flex;
     align-items: center;
     justify-content: center;
     gap: 2rem;
     position: relative;
     width: 100%;
     max-width: min(1200px, 90%);
     overflow: hidden;
 }

 .product-item {
     border-radius: 10px;
     transition: all 0.5s ease;
     cursor: pointer;
     opacity: 0.7;
     position: relative;
     flex-shrink: 0;
 }

 .product-item.active {
     opacity: 1;
     z-index: 2;
 }


 /* 兼容之前的data-index样式 */
 .product-item[data-index="0"],
 .product-item[data-index="4"] {
     width: 7rem;
     height: 7rem;
 }

 .product-item[data-index="1"],
 .product-item[data-index="3"] {
     width: 9rem;
     height: 9rem;
 }

 .product-item[data-index="2"] {
     width: 12rem;
     height: 12rem;
 }

 .product-image {
     width: 100%;
     height: 100%;
     object-fit: cover;
     border-radius: 10px;
 }

 .carousel-dots {
     display: flex;
     justify-content: center;
     gap: 0.5rem;
     margin-top: 1rem;
 }

 .dot {
     width: 10px;
     height: 10px;
     border-radius: 50%;
     background-color: #ccc;
     cursor: pointer;
     transition: all 0.3s ease;
 }

 .dot.active {
     background-color: #64B800;
     transform: scale(1.2);
 }

 .nav-dropdown-toggle-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
 }

 .carousel-dots {
     display: flex;
     justify-content: center;
     gap: 0.5rem;
     margin-top: 1rem;
 }

 .dot {
     width: 10px;
     height: 10px;
     background: #ddd;
     border-radius: 50%;
     cursor: pointer;
 }

 .dot.active {
     background: #64B800;
 }

 /* Delivery Section */
 .delivery-content {
     opacity: 1;
     display: grid;
     width: 100%;
     max-width: 75rem;
     grid-template-columns: 1fr 1fr;
     align-items: center;
     margin: 0 auto;
 }


 .delivery-left {
     display: flex;
     flex-direction: column;
     gap: 2rem;
     width: 100%;
     max-width: 30rem;
 }

 .delivery-title {
     font-size: 1.5rem;
     font-weight: bold;
     margin-bottom: 0;
     color: #000000;
 }

 /* PC端和移动端标题控制 */
 .delivery-title.pc-title {
     display: block;
 }

 .delivery-title.mobile-title {
     display: none;
 }

 .delivery-title-success {
     font-size: 1.5rem;
     font-weight: bold;
     margin-bottom: 0;
     color: #64B800;
 }

 .delivery-table {
     background: white;
     border-radius: 10px;
     padding: 1.5rem;
     box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
     flex: 1;
 }

 .tab-container {
     width: 100%;
 }

 .tab-buttons {
     display: flex;
     margin-bottom: 1.5rem;
     border-bottom: 2px solid #eee;
 }

 .tab-button {
     background: none;
     border: none;
     padding: 1rem 1.5rem;
     font-size: 1.2rem;
     font-weight: 500;
     color: #666;
     cursor: pointer;
     border-bottom: 0.08rem solid transparent;
     transition: all 0.3s;
     flex: 1;
     text-align: center;
 }

 .tab-button:hover {
     color: #64B800;
 }

 .tab-button.active {
     color: #64B800;
     border-bottom-color: #64B800;
 }

 .tab-content {
     position: relative;
     text-align: center;
 }

 .tab-panel {
     display: none;
 }

 .tab-panel.active {
     display: block;
 }

 .table-title {
     font-size: 1.2rem;
     font-weight: bold;
     margin-bottom: 1rem;
     color: #333;
 }

 table {
     width: 100%;
     border-collapse: collapse;
     margin: 0 auto;
 }

 th,
 td {
    width: 8rem;
     padding: 0.6rem;
     text-align: center;
     border: none;
     font-size: 0.9rem;
     font-weight: 600;
 }

 th {
     background: #f8f8f8;
     font-weight: bold;
 }

.delivery-image {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 10px;
    width: 100vw;
    height: 528px;
    margin-left: -10rem;
    padding-left: 2rem;
}
.delivery-scontent{
    width: 100%;
    height: 528px;
    position: relative;
    z-index: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.delivery-scontent img{
    width: 100vw;
    height: 528px;
    display: block;
    position: absolute;
    z-index: -1;
}
.delivery-stitle{
    font-size: 1.9rem;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 1rem;
    line-height: 1.7;
    margin-bottom: 2rem;
    position: relative;
    right: 230px;
}
.delivery-name{
    font-size: 1.9rem;
    font-weight: 700;
    color: #FFFFFF;
    margin-bottom: 1rem;
    line-height: 1.8;
    position: relative;
    right: 230px;
}

 /* Operation Flow */
 .section:nth-of-type(4) {
     background: url('@/assets/images/liucheng.png');
     background-size: cover;
     background-position: center;
     background-repeat: no-repeat;
     width: 100%;
     padding: 4rem 0;
 }

 .btn-default {
     width: 19.69rem;
     height: 3.12rem;
     border-radius: 0.25rem;
     opacity: 1;
     background: white;
     border: 1px solid #64B800;
     font-size: 0.9rem;
     font-weight: 500;
     line-height: 3.12rem;
     margin-top: 1rem;
     text-align: center;
     color: #64B800;
     padding: 0;
     cursor: pointer;
     transition: all 0.3s;
     display: inline-block;
     vertical-align: middle;
     box-sizing: border-box;
 }


 .flow-steps {
     display: grid;
     grid-template-columns: repeat(5, 1fr);
     gap: 2rem;
     margin: 3rem 0;
 }

 .flow-step {
     text-align: center;
     position: relative;
 }

 .step-content {
     margin-top: 1rem;
 }

 .flow-arrow {
     display: none;
 }

 .flow-step:not(:last-child)::after {
     content: '';
     position: absolute;
     right: -1rem;
     top: 50%;
     transform: translateY(-50%);
     width: 0.75rem;
     height: 0.75rem;
     background: url('@/assets/images/guide.png');
     background-size: contain;
     background-repeat: no-repeat;
 }

 .step-icon {
     width: 4rem;
     height: 4rem;
     border-radius: 50%;
     background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;
     box-shadow: 0px 5.14px 7.72px -4px rgba(0, 0, 0, 0.1), 0px 12.86px 19.29px -3px rgba(0, 0, 0, 0.1);
     display: flex;
     align-items: center;
     justify-content: center;
     margin: 0 auto;
     margin-top: 1.2rem;

 }

 .step-icon-img {
     width: 3.5rem;
     height: 3.5rem;
 }

 .step-title-text {
     font-size: 1.1rem;
     font-weight: 500;
     text-align: center;
     color: #000000;
     margin-top: 1.25rem;
 }

 .step-title {
     width: 4rem;
     height: 1.5rem;
     border-radius: 0.75rem;
     font-size: 0.9rem;
     font-weight: 500;
     line-height: 1.5rem;
     background: #374151;
     color: #FFFFFF;
     text-align: center;
     margin: 0 auto;
 }

 /* Platform Integration */
 .platform-content {
     display: grid;
     grid-template-columns: 1fr 1fr;
     gap: 3rem;
     align-items: center;
 }

 .platform-logos {
     display: grid;
     grid-template-columns: repeat(2, 1fr);
     gap: 1rem;
     row-gap: 1.5rem;
 }

 .platform-logo {
     background: none;
     padding: 0;
     border-radius: 0;
     text-align: center;
     display: flex;
     align-items: center;
     justify-content: center;
 }

 .platform-logo-img {
     height: 8rem;
     border-radius: 0.5rem;
     opacity: 1;
     background: #FFFFFF;
     box-sizing: border-box;
     object-fit: contain;
     display: block;
     margin: 0;
     padding: 0;
     outline: none;
 }

 .platform-buttons {
     display: flex;
     gap: 1rem;
     margin-top: 2rem;
 }

 /* Image Grid */
 .image-grid-container {
     position: relative;
     width: 100vw;
     left: 50%;
     transform: translateX(-50%);
     overflow: hidden;
     margin: 2rem 0;
     z-index: 1;
     max-width: none;
     box-sizing: border-box;
     padding: 0;
 }

 .image-grid {
     display: flex;
     flex-direction: column;
     gap: 30px;
 }

 .image-row {
     display: flex;
     flex-direction: row;
     gap: 1.5rem;
     animation: scrollRight 30s linear infinite;
     width: calc(9 * 12rem + 8 * 1.5rem);
     /* 9张图片 + 8个间距，匹配实际HTML内容 */
 }

 .image-grid-img {
     width: 20rem;
     height: 12.5rem;
     border-radius: 0.2rem;
     opacity: 1;
     flex-shrink: 0;
 }

 /* PC端隐藏移动端单独图片 */
 .mobile-image-single {
     display: none;
 }

 @keyframes scrollRight {
     0% {
         transform: translateX(0);
     }

     100% {
         transform: translateX(calc(-6 * 12rem - 5 * 1.5rem));
         /* 移动6张图片的距离，确保无缝循环 */
     }
 }

 .grid-item {
     background: #f8f8f8;
     height: 6rem;
     border-radius: 10px;
     display: flex;
     align-items: center;
     justify-content: center;
     color: #999;
     font-size: 0.9rem;
 }

 /* Advantages */
.advantages-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr 1fr;
    gap: 2rem;
    margin: 3rem auto;
    max-width: 80rem;
    justify-items: center;
    align-items: stretch;
}

.advantage-card {
    width: 100%;
    max-width: 36.5rem;
    height: 100%;
    border-radius: 0.75rem;
    opacity: 1;
    background: #FFFFFF;
    box-shadow: 0px 7px 29px 0px rgba(100, 100, 111, 0.2);
    display: flex;
    flex-direction: column;
}

.advantage-content {
    width: 85%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    flex: 1;
  padding-bottom: 1rem;
}

 .advantage-icon-title {
     font-size: 1.5rem;
     font-weight: bold;
     color: #374151;
 }


 .advantage-icon-content {
     display: flex;
     flex-flow: row nowrap;
     margin-top: 2rem;
     gap: 0.75rem;
     align-items: center;
 }

 .advantage-icon {
     width: 60px;
     height: 60px;
     background: #64B800;
     border-radius: 50%;
     display: flex;
     align-items: center;
     justify-content: center;
     margin: 0 auto 1rem;
     color: white;
     font-size: 1.5rem;
 }

 .advantage-icon-img {
     width: 1.87rem;
     height: 1.87rem;
 }

.advantage-icon-text {
    font-size: 1rem;
    font-weight: normal;
    color: #374151;
    margin-top: 1rem;
    opacity: 0.8;
}

/* English language specific styling for PC */
html[lang="en"] .advantage-icon-text {
    font-size: 0.85rem;
}

 .global-map {
     /* height: 430px; */
     margin: 0 auto;
     display: block;
 }

 /* News */
 .news-grid {
     display: grid;
     grid-template-columns: repeat(3, 1fr);
     gap: 2rem;
     margin: 3rem 0;
 }

 .news-card {
     background: white;
     border-radius: 10px;
     overflow: hidden;
     box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
 }

 .news-image {
     width: 389px;
     height: 192px;
     background: #f8f8f8;
     display: flex;
     align-items: center;
     justify-content: center;
     color: #999;
 }

 .news-content {
     padding: 1.5rem;
 }

 .news-title {
     font-weight: bold;
     margin-bottom: 0.5rem;
 }

 .news-date {
     color: #666;
     font-size: 0.9rem;
 }


 /* Final CTA */
 .final-cta {
     padding: 20px 0;
     width: 100%;
     max-width: 77.5rem;
     /* height: auto; */
     min-height: 12rem;
     border-radius: 0.5rem;
     opacity: 1;
     /* background: url('@/assets/images/cta_bg.png');
     background-size: cover;
     background-position: center;
     background-repeat: no-repeat; */
     margin: 0 auto;
     color: black;
     text-align: left;
     margin-bottom: 5rem;
     position: relative;
 }

 html[lang="en"] .final-cta {
    height: 220px;
}
 html[lang="en"] .final-cta .cta-right-content {
    top:6.8rem;
}
 /* html[lang="ru"] .final-cta {
    height: 220px;
}
 html[lang="ru"] .final-cta .cta-right-content {
    top:6.8rem;
} */
 html[lang="mn"] .final-cta {
    height: 220px;
}
 html[lang="mn"] .final-cta .cta-right-content {
    top:6.8rem;
}


 /* .final-cta::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 0;
} */

 .cta-content {
     max-width: 800px;
     margin: 0 auto;
 }

 .cta-left-content {
     position: absolute;
     left: 17rem;
     top: 2.4rem;
 }

 .cta-title-text {
     max-width: 380px;
     font-family: Roboto;
     font-size: 1.3rem;
     font-weight: 500;
     color: #000;
     /* text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3); */
     margin-bottom: 0.75rem;
 }

 .cta-right-content-item {
     font-size: 0.8rem;
     font-weight: normal;
     color: #000;
     margin-bottom: 0.75rem;

 }

 .cta-right-content-item:last-child {
     margin-bottom: 0;
 }

 .cta-right-content-item-img {
     width: 0.5rem;
     height: 0.4rem;
     margin-right: 0.25rem;
 }

 .cta-button {
     width: 7.5rem;
     height: 2.5rem;
     border-radius: 0.25rem;
     opacity: 1;
     background: #64B800;
     border: none;
     font-size: 0.9rem;
     font-weight: 500;
     color: #FFFFFF;
     cursor: pointer;
     transition: background 0.3s;
     text-decoration: none;
     display: inline-block;
     text-align: center;
     line-height: 2.5rem;
 }

 .cta-button:hover {
     background: #5eac00;
 }

 .cta-right-content {
     position: absolute;
     left: 40rem;
     top: 4.5rem;

 }

 .cta-title {
     font-size: 2.5rem;
     margin-bottom: 2rem;
 }

 .benefits-list {
     display: flex;
     justify-content: center;
     gap: 2rem;
     margin: 2rem 0;
     flex-wrap: wrap;
 }

 .benefit-item {
     display: flex;
     align-items: center;
     gap: 0.5rem;
 }

 .checkmark {
     color: #4CAF50;
     font-weight: bold;
 }

/* Footer */
.footer {
    background: #16182C;
    color: white;
    padding: 3rem 0 1rem;
}

 .footer-content {
     display: grid;
     grid-template-columns: auto 1fr;
     gap: 10.8rem;
     margin-bottom: 2rem;
     align-items: center;
 }

 .footer-logo {
     display: flex;
     align-items: center;
     gap: 0.5rem;
     margin-bottom: 1rem;
 }

 .footer-logo-img {
    width: 220px;
    height:66px;
}

 .social-icons {
     display: flex;
     gap: 1rem;
     margin: 1rem 0;
 }

 .footer-left-content {
     max-width: 20rem;
     flex-shrink: 0;
     display: flex;
     flex-direction: column;
     justify-content: center;
     align-items: flex-start;
 }

 .contact-us {
    font-size: 0.875rem;
    max-width: 18.4rem;
    font-weight: normal;
    color: rgba(255, 255, 255, 0.5);
    margin: 1rem 0 0 0;
    opacity: 0.8;
    margin-top: 0.75rem;
}



 .social-icon {
     width: 2.5rem;
     height: 2.5rem;
     background: #555;
     border-radius: 50%;
     display: flex;
     align-items: center;
     justify-content: center;
     cursor: pointer;
     margin-top: 2.6rem;
     transition: background 0.3s;
 }

 .social-icon:hover {
     background: #64B800;
 }

 .footer-nav {
     display: flex;
     gap: 4.5rem;
     justify-content: space-around;
     margin-bottom: 1rem;
     flex-wrap: nowrap;
     align-items: flex-start;
     margin-top: 1rem;
 }

 .footer-nav a {
     color: white;
     text-decoration: none;
     transition: color 0.3s;
     font-size: 0.875rem;
     font-weight: normal;
     opacity: 0.6;
     margin-bottom: 0.6rem;
     line-height: 1.4;
 }

 .footer-nav a:hover {
     color: #64B800;
 }

 /* 有图片的链接样式 */
 .footer-nav a.has-icon {
     display: inline-block;
     vertical-align: top;
     margin-bottom: 1rem;
 }

 /* 没有图片的链接样式 */
 .footer-nav a:not(.has-icon) {
     display: block;
 }

 .footer-content-icon {
     width: 1rem;
     height: 1rem;
     flex-shrink: 0;
     vertical-align: top;
     display: inline-block;
     margin-right: 0.5rem;
     margin-top: 0.2rem;
 }

 .second-nav {
     opacity: 0.5;
     font-size: 0.8rem;
     font-weight: normal;
     color: #FFFFFF;
 }

 .footer-divider {
    display: none;
 }

 .footer-group {
     display: flex;
     flex-direction: column;
     gap: 0.5rem;
     min-width: 0;
     /* flex: 1; */
 }

 /* 图片和链接在同一行的容器样式 */
 .footer-group .footer-content-icon + a.has-icon {
     margin-bottom: 0.5rem;
 }

 .footer-group a:first-child {
     font-weight: 500;
     margin-bottom: 0.25rem;
     font-size: 1.1rem;
     color: #ffffff;
     opacity: 1;

 }


 .copyright {
     text-align: center;
     padding-top: 2rem;
     /* border-top: 1px solid #555; */
     color: #999;
 }
.qirui-pc-iframe{
  width: 100%;
  position: relative;
}
.qirui-pc-bg{
  width: 100%;
  height: 500px;
}
.qirui-pc-content{
  position: absolute;
  bottom: 60px;
  left: 60px;
}
.qirui-pc-title{
  font-family: Source Han Sans;
  font-size: 2em;
  font-weight: 900;
  line-height: 36px;
  letter-spacing: 0em;
  color: #FFFFFF;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
}
.qirui-pc-con{
  font-family: Source Han Sans;
  font-size: 1em;
  letter-spacing: 0em;
  color: #FFFFFF;
  font-weight: 350; 
  width: 700px;
}
.qirui-pc-con span{
  font-weight: 900; 
}
.qirui-pc-btn{
  width: 124px;
  border-radius: 5.6px;
}



/* Responsive */
/* 大屏幕适配 */
@media (max-width: 1920px) {
    .header-container {
        gap: 120px;
        padding: 0 1.8rem;
    }

    .nav {
        gap: 1.8rem;
    }
}

/* 中等屏幕适配 */
@media (max-width: 1600px) {
    .header-container {
        gap: 100px;
        padding: 0 1.6rem;
    }

    .nav {
        gap: 1.6rem;
    }
}

/* 小屏幕适配 */
@media (max-width: 1366px) {
    .header-container {
        gap: 80px;
        padding: 0 1.4rem;
    }

    .nav {
        gap: 1.4rem;
    }
}

/* 更小屏幕适配 */
@media (max-width: 1200px) {
    .header-container {
        gap: 60px;
        padding: 0 1.2rem;
    }

    .nav {
        gap: 1.2rem;
    }
}

/* 统一移动端样式：所有小于等于1024px的设备都使用移动端样式 */

 @media (max-width: 1024px) {

     /* 移动端适配 - 包括平板和手机 */
    .header {
        padding: 0;
        height: 3.5rem;
        z-index: 1001;
    }

    .header-container {
        gap: 0;
        padding: 0 1rem;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 3.5rem;
    }

    .logo {
        flex-shrink: 0;
        min-width: 120px;
        display: flex;
        align-items: center;
        height: 100%;
    }

    .logo img {
         height: 60px !important;
         width: 200px !important;
        object-fit: contain;
    }

     .nav {
         display: none;
     }

     /* 移动端导航下拉菜单 */
     .nav-dropdown {
         position: relative;
     }

     .nav-dropdown-menu {
         position: static;
         opacity: 1;
         visibility: visible;
         transform: none;
         box-shadow: none;
         background: transparent;
         padding: 0;
         margin-top: 0.5rem;
         margin-left: 1rem;
     }

     .nav-dropdown-menu a {
         padding: 0.5rem 0;
         font-size: 0.9rem;
         color: #666;
         border-bottom: 1px solid #eee;
     }

     .nav-dropdown-menu a:last-child {
         border-bottom: none;
     }

     .nav-dropdown-icon {
         display: none;
     }
     .delivery-scontent{
    height: 183px;
}
.delivery-scontent img{
    height: 183px;
}
.delivery-stitle{
    font-size: 0.7rem;
    font-weight: 500;
    color: #FFFFFF;
    margin-bottom: 1.5rem;
    line-height: 1.3;
    position: relative;
    right: 60px;
    top: 10px;
}
html[lang="en"] .delivery-stitle,
html[lang="mn"] .delivery-stitle {
    right: 30px;
}
html[lang="ru"] .delivery-stitle {
    right: 0px;
}
.delivery-name{
    font-size: 0.7rem;
    font-weight: 500;
    color: #FFFFFF;
    margin-bottom: 1rem;
    line-height: 1.3;
    position: relative;
    right: 60px;
    top: 10px;
}

html[lang="en"] .delivery-name,
html[lang="mn"] .delivery-name {
    right: 30px;
}
html[lang="ru"] .delivery-name {
    right: 10px;
}
}

.gotoWeb{
    max-width: 830px;
    height: 68px;
    margin: 20px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 146px 0 88px;
    background: url('@/assets/images/gotobg.png');
    background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

}

.gotoWeb-icon{
    width: 197px;
    height: 46px;
}

.gotoWeb-tip{
    display: flex;
    align-items: center;
    color: #38A700;
    font-family: Roboto;
    cursor: pointer;
    margin-left: 9px;
}

.qirui-mobile-iframe{
  position: relative;
}

.qirui-mobile-bg{
  width: 100%;
  /* height: 500px; */
}
.qirui-mobile-content{
  position: absolute;
  top: 60px;
  width: 100%;
  padding: 0 20px;
  text-align: center;
}
.qirui-mobile-title{
  font-family: Source Han Sans;
  font-size: 15px;
  font-weight: 900;
  line-height: 18px;
  color: #FFFFFF;
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.08);
  margin-bottom: 13px;
  margin-top: 19px;
}
.qirui-mobile-con{
  font-family: Source Han Sans;
  font-size: 12px;
  letter-spacing: 0em;
  color: #FFFFFF;
}
.qirui-mobile-con span{
  font-weight: 900; 
}
.qirui-mobile-btn{
    width: 290px;
    height: 44px;
    border-radius: 2px;
    /* 纯白 */
    background: #FFFFFF;
    font-size: 18px;
    color: #64B800;
    line-height: 44px;
    text-align: center;
    border: none;
    margin-top: 26px;
	
}



@media (max-width: 1024px) {
    /* 移动端语言选择器样式 */
    .language-dropdown-toggle {
        padding: 0.5rem 0.75rem;
        font-size: 0.9rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .language-dropdown-menu {
        /* position: static; */
        background: #FFF !important;
        opacity: 0;
        visibility: hidden;
        transform: none;
        box-shadow: none;
        background: transparent;
        padding: 0;
        min-width: auto;
        max-height: 0;
        overflow: hidden;
        transition: all 0.3s ease;
    }

    .language-dropdown.active .language-dropdown-menu {
        opacity: 1;
        visibility: visible;
        max-height: 200px;
    }

    .language-dropdown-menu .language-option {
        padding: 0.75rem 1rem;
        font-size: 0.9rem;
        color: #374151;
        border-bottom: 1px solid #eee;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        border-radius: 4px;
        margin: 0.25rem 0;
    }

    .language-dropdown-menu .language-option:last-child {
        border-bottom: none;
    }

    .language-dropdown-menu .language-option:hover {
        background-color: rgba(100,184, 0, 0.1);
        color: #64B800;
    }
    .language-option:focus {
  outline: none;  /* 移除焦点轮廓 */
  background-color: rgba(100,184, 0, 0.1);  /* 自定义焦点样式 */
}

    .language-dropdown-icon {
        display: block !important;
        width: 0.6rem;
        height: 0.6rem;
        /* transition: transform 0.3s ease; */
    }

    .language-dropdown.active .language-dropdown-icon {
        transform: none;
    }

    /* 移动端禁用hover效果 */
    .language-dropdown:hover .language-dropdown-icon {
        transform: none !important;
    }

    .mobile-menu-toggle {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        justify-content: center;
         height: 2.5rem;
         width: 2.5rem;
    }

     .header-right {
         gap: 0.25rem;
         display: flex;
         align-items: center;
         justify-content: flex-end;
         flex-shrink: 0;
         min-width: 10rem;
         height: 100%;
     }

    .language-selector {
        display: flex !important;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        /* width: 6rem; */
        height: 2.5rem;
        margin-right: 0;
        padding: 0;
        position: relative;
    }

    .language-icon {
        width: 1.25rem;
        height: 1.25rem;
        flex-shrink: 0;
        background: url('@/assets/images/language.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }

     .language-dropdown {
         position: relative;
         display: inline-block;
         /* width: 100%; */
     }

    .language-select {
        width: 100%;
        background: none;
        border: 1px solid transparent;
        padding: 0.25rem 0.5rem;
        font-size: 0.9rem;
        color: #666;
        cursor: pointer;
        border-radius: 6px;
        appearance: none;
        padding-right: 1.5rem;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%23E2430E' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
        background-position: right 0.5rem center;
        background-repeat: no-repeat;
        background-size: 1rem;
        transition: all 0.3s ease;
        text-align: center;
        outline: none;
    }

    .language-select:hover {
        color: #64B800;
        border-color: #64B800;
        background-color: rgba(226, 67, 14, 0.05);
    }

    .language-select:focus {
        outline: none;
        color: #64B800;
        border-color: #64B800;
        background-color: rgba(100,184, 0, 0.1);
        box-shadow: 0 0 0 2px rgba(226, 67, 14, 0.2);
    }

    /* 移动端下拉选项样式 - 复制PC端样式 */
    .language-select option {
        background-color: #ffffff !important;
        color: #374151 !important;
        padding: 0.5rem 0.75rem !important;
        font-size: 0.95rem !important;
        font-weight: 500 !important;
        border: none !important;
        font-family: inherit !important;
    }

     .language-select option:hover {
         background-color: rgba(100,184, 0, 0.1) !important;
         font-size: 0.95rem !important;
         color: #64B800 !important;
     }

     .language-select option:checked {
         background-color: #64B800 !important;
         font-size: 0.95rem !important;
         color: #ffffff !important;
         font-weight: 600 !important;
     }

    /* 通用下拉选项样式 - 确保跨浏览器兼容 */
    select.language-select option {
        background-color: #ffffff !important;
        color: #374151 !important;
        padding: 0.5rem 0.75rem !important;
        font-size: 0.95rem !important;
        font-weight: 500 !important;
        border: none !important;
        font-family: inherit !important;
    }

     select.language-select option:hover {
         background-color: rgba(100,184, 0, 0.1) !important;
         font-size: 0.95rem !important;
         color: #64B800 !important;
     }

     select.language-select option:checked {
        font-size: 0.95rem !important;
         background-color: #64B800 !important;
         color: #ffffff !important;
         font-weight: 600 !important;
     }

     .register-button {
         display: none;

     }

    .logo img {
        height: 2.5rem !important;
        width: 8.4rem !important;
        display: flex;
        align-items: center;
    }

     .hero {
         margin-top: -1.8rem;
         background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('@/assets/images/banner_mobile.jpg') !important;
         background-size: cover !important;
         background-position: center !important;
         background-repeat: no-repeat !important;
     }

    .hero-container {
        position: static;
        left: auto;
        top: auto;
        padding: 2rem 1rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 3rem;
        margin-top: 4rem;
        text-align: center;
    }

    .hero-image {
        display: none;
    }


    .hero-register-button {
        width: 100%;
        max-width: 81.25rem;
        height: 4rem;
        border-radius: 0.5rem;
        opacity: 1;
        background: rgba(0, 0, 0, 0);
        color: white;
        border: 1px solid white;
        font-weight: 500;
        cursor: pointer;
        transition: background 0.3s;
        text-decoration: none;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.3rem;
        margin: -3rem 0 0 0;
    }

     .stats {
         /* flex-direction: column; */
         gap: 1rem;
         margin-top: 2rem;
         margin-left: 1rem;
         margin-bottom: 2rem;
         align-items: flex-start;
     }

     .stats>div[style*="width: 60px"] {
         display: none;
     }

     .stat {
         flex-direction: column;
       text-align: center;
     }

    .stat img {
        width: 40px;
        height: 40px;
    }

    .stat-number {
        font-size: 1.5rem;
        white-space: nowrap;
        letter-spacing: 0.02em;
    }

    .stat>div>div:last-child {
        font-size: 0.9rem;
        white-space: wrap;
    }

     .footer-nav {
        display: flex;
        flex-wrap: nowrap;
         gap: 1rem;
     }

     .footer-group {
         gap: 0.5rem;
         width: 100%;
     }

     .second-nav {
         opacity: 0.5;
         font-size: 0.9rem;
         font-weight: normal;
         color: #FFFFFF;
     }

     .footer-group a:first-child {
         margin-bottom: 0.125rem;
     }

     .language-selector {
         margin-right: 0;
         align-self: center;
     }

     .hero-container,
     .delivery-content {
         grid-template-columns: 1fr;
         /* margin-top: 6rem; */
     }

     .platform-content {
         display: flex;
         flex-direction: column;
         gap: 2rem;
         position: relative;
     }

     .platform-content > div:first-child {
         display: flex;
         flex-direction: column;
         gap: 2rem;
     }

     .platform-content .platform-logos {
         position: absolute;
         top: 50%;
         left: 0;
         right: 0;
         transform: translateY(-50%);
         z-index: 1;
     }

     .platform-content > div:first-child > div:first-child {
         order: 1;
         margin-bottom: 8rem;
     }

     .platform-content > div:first-child > div:last-child {
         order: 3;
         margin-top: 3rem;
     }



     html[lang="en"] .platform-content > div:first-child > div:last-child {
        order: 3;
        /* margin-top: 6rem; */
    }

     .delivery-title {
         font-size: 2rem;
     }

     .tab-buttons {
         flex-direction: column;
     }

     .tab-button {
         text-align: center;
         border-bottom: none;
         border-right: 2px solid transparent;
     }

     .tab-button.active {
         border-bottom-color: transparent;
         border-right-color: #64B800;
     }

     .flow-steps {
         grid-template-columns: 1fr;
     }

     .flow-step:not(:last-child)::after {
         display: none;
     }

     .product-grid {
         grid-template-columns: repeat(3, 1fr);
     }

     .image-grid {
         gap: 1rem;
     }

     .image-row {
         gap: 15px;
         width: calc(9 * 120px + 8 * 1rem);
     }

     .image-grid-img {
         width: 120px;
         height: 75px;
     }

     @keyframes scrollRight {
         0% {
             transform: translateX(0);
         }

         100% {
             transform: translateX(calc(-6 * 120px - 5 * 1rem));
         }
     }
     .gywm-subtitle{
        text-align: left;
     }
 }

/* Mobile styles */
@media (max-width: 1024px) {
    .product-carousel {
        height: 15rem;
        margin: 2rem 0;
    }

     .carousel-container {
         gap: 1rem;
         max-width: 100%;
     }

    .product-item {
        width: 80px;
        height: 80px;
    }


     /* 兼容之前的data-index样式 - 移动端 */
    .product-item[data-index="0"],
    .product-item[data-index="4"] {
        width: 120px;
        height: 120px;
    }

    .product-item[data-index="1"],
    .product-item[data-index="3"] {
        width: 150px;
        height: 150px;
    }

    .product-item[data-index="2"] {
        width: 180px;
        height: 180px;
    }

    .image-grid {
        gap: 1rem;
        display: none !important;
    }

    .image-row {
        gap: 0.5rem;
        width: calc(9 * 100px + 8 * 0.5rem);
    }

    .image-grid-img {
        width: 100px;
        height: 60px;
    }

     /* 移动端单独图片样式 */
     .mobile-image-single {
        max-width: none;
         display: block;
         text-align: center;
         margin: 2rem 0;
     }

    .mobile-single-img {
        width: 100%;
        height: auto;
    }

     @keyframes scrollRight {
         0% {
             transform: translateX(0);
         }

         100% {
             transform: translateX(calc(-6 * 20rem - 5 * 1rem));
         }
     }

     .delivery-content {
         grid-template-columns: 1fr;
         gap: 2rem;
         width: 100%;
         padding: 0 1rem;
     }

     .delivery-left {
         order: 2;
     }

    .delivery-image {
        order: 1;
        width: 100vw;
        height: auto;
        min-height: 200px;
        margin-left: calc(-50vw + 50%);
        padding-left: 0;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        max-width: none;
    }

    .delivery-title {
        font-size: 1.5rem;
        text-align: center;
        white-space: pre-line;
    }

     /* 移动端标题控制 */
     .delivery-title.pc-title {
         display: none !important;
     }

     .delivery-title.mobile-title {
         display: block !important;
         margin-top: 1rem;
         margin-bottom: 1rem;
     }

     .delivery-title br {
         display: block;
     }

    .delivery-title-success {
        font-size: 1.5rem;
        text-align: center;
    }

     .tab-buttons {
         justify-content: center;
         margin-bottom: 1.2rem;
         flex-direction: row;
         border-bottom: 0.2rem solid #eee;
     }

     .tab-button {
         flex: 1;
         text-align: center;
         border-bottom: 0.2rem solid transparent;
         border-right: none;
         padding: 0.75rem 0.5rem;
         margin: 0;
         font-size: 1.1rem;
     }

     .tab-button.active {
         border-bottom-color: #64B800;
         border-right-color: transparent;
     }

     .advantages-grid,
     .news-grid {
         grid-template-columns: 1fr;
     }

     .platform-buttons {
         flex-direction: column;
         gap: 1rem;
         align-items: center;
         margin-top: 1.5rem;
     }

    .platform-buttons .btn-primary-1,
    .platform-buttons .btn-default {
        width: 100%;
        max-width: 280px;
        margin: 0;
        height: 45px;
        line-height: 45px;
        font-size: 1rem;
    }
    .btn-default{
        background: rgba(100, 184, 0, 0.08);
        border: none;
    }

     .platform-logos {
         grid-template-columns: repeat(2, 1fr);
         gap: 1rem;
         /* margin: 2rem 0; */
     }

    .platform-logo-img {
        /* width: 7.5rem; */
        height: 5rem;
        border-radius: 0.375rem;
    }

     .gotoWeb{
    max-width: 100%;
    height: 100px !important;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px 0 20px;
    background: url('@/assets/images/gotobg-mobile.png');
    background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

}
    
.gotoWeb-icon{
    height: 44px;
}

.gotoWeb-tip{
    display: flex;
    align-items: center;
    color: #38A700;
    font-family: Roboto;
    cursor: pointer;
    margin-left: 9px;
    white-space: nowrap;
}

    .final-cta {
        width: 100%;
        height: auto;
        padding: 2rem 1rem;
        margin-bottom: 0;
        border-radius: 0 !important;
        /* background: url('@/assets/images/bottom-bg.png') !important; */
        /* background-size: cover !important;
        background-position: center !important;
        background-repeat: no-repeat !important; */
    }

    .final-cta.advantage-card{
        width: 82% !important;
        margin-bottom: 20px;
    }

     .cta-left-content {
         position: static;
         left: auto;
         top: auto;
         text-align: center;
         margin-bottom: 2rem;
         display: flex;
         flex-direction: column;
         align-items: center;
         gap: 1.5rem;
     }

    .cta-title-text {
        font-size: 1.3rem;
        line-height: 1.4;
        margin-bottom: 0;
    }

    .cta-button {
        width: 200px;
        height: 45px;
        line-height: 45px;
        font-size: 1rem;
    }

     .cta-right-content {
         position: static;
         left: auto;
         top: auto;
         text-align: center;
         margin: 0 auto;
         width: fit-content;
     }

    .cta-right-content-item {
        font-size: 0.9rem;
        margin-bottom: 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 0.5rem;
        text-align: left;
    }

    .cta-right-content-item-img {
        width: 16px;
        height: 16px;
    }

     .benefits-list {
         flex-direction: column;
         align-items: center;
     }

    /* 通用section适配 */
    .section {
        margin-top: 3rem;
    }

     .container,
     .container-2 {
         padding: 0 1rem;
     }

    .section-title {
        font-size: 1.5rem;
        margin-bottom: 0.75rem;
        line-height: 1.3;
        width: 100%;
        max-width: 90%;
        margin-left: auto;
        margin-right: auto;
        white-space: pre-line;
    }


     .section-title br {
         display: block;
     }

     /* PC端隐藏移动端的换行，并添加逗号 */
     @media (min-width: 769px) {
         .section-title br {
             display: none;
         }

         .section-title br::after {
             content: '，';
         }

         .delivery-title br {
             display: none;
         }

         .delivery-title br::after {
             content: '，';
         }
     }

    .success-text,
    .success-text-2 {
        font-size: 1.5rem;
    }

    .section-subtitle {
        font-size: 0.9rem;
        line-height: 1.5;
        margin-bottom: 1rem;
        width: 100%;
        max-width: 90%;
        margin-left: auto;
        margin-right: auto;
    }

    /* 平台section标题适配 */
    .platform-section-title {
        font-size: 1.5rem;
        text-align: center;
        margin-bottom: 0.75rem;
    }

    .platform-section-subtitle {
        font-size: 0.8rem;
        text-align: left;
        margin-bottom: 1.5rem;
        text-indent: 2em;
    }

     /* 操作流程section适配 */
     .section:nth-of-type(4) {
         background: url('@/assets/images/liucheng_mobile.png') !important;
         background-size: cover !important;
         background-position: center !important;
         background-repeat: no-repeat !important;
         padding: 2rem 0;
         margin-top: 3rem;
     }

     .flow-steps {
         flex-direction: column;
         gap: 0.1rem;
         padding: 0 1rem;
     }

     .flow-step {
         position: relative;
         left: 0;
         top: 0;
         width: 100%;
         height: auto;
         opacity: 1;
         border: 0 solid #E4E4E4;
         background: #ffffff;
         border-radius: 1rem;
         box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.1);
         display: flex;
         align-items: center;
         padding: 1rem;
         margin: 0 auto;
     }

     .flow-step:not(:last-child)::after {
         display: none;
     }

     .flow-arrow {
         display: block;
         width: 1.1rem;
         height: 1.1rem;
         background: url('@/assets/images/arrow-down.png');
         background-size: contain;
         background-repeat: no-repeat;
         background-position: center;
         margin: 0 auto;
     }

    .step-icon {
        width: 60px;
        height: 60px;
        margin: 0;
        flex-shrink: 0;
        margin-left: 1rem;
    }

     .step-icon-img {
         width: 100%;
         height: 100%;
         object-fit: contain;
     }

     .step-content {
         flex: 1;
         margin-left: 1rem;
         margin-top: 0;
         display: flex;
         flex-direction: column;
         justify-content: center;
         text-align: left;
     }

    .step-title {
        font-size: 0.9rem;
        font-weight: normal;
        color: #374151;
        margin-bottom: 0.5rem;
        background: none !important;
        border: none !important;
        border-radius: 0 !important;
        width: auto !important;
        height: auto !important;
        line-height: normal !important;
        text-align: left !important;
        margin: 0 0 0.5rem 0 !important;
    }

    .step-title-text {
        font-size: 1.2rem;
        font-weight: 500;
        color: #374151;
        margin: 0;
        line-height: 1.2;
        text-align: left;
    }

     /* 优势section适配 */
    .advantages-grid {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(4, auto);
        gap: 1.5rem;
        padding: 0 1rem;
        align-items: stretch;
    }

    .advantage-card {
        width: 100% !important;
        height: auto !important;
        min-height: auto !important;
        border-radius: 1rem !important;
        opacity: 1 !important;
        background: #FFFFFF !important;
        box-shadow: 0px 7px 29px 0px rgba(100, 100, 111, 0.2) !important;
        display: flex !important;
        flex-direction: column !important;
    }

    .advantage-content {
        width: 100% !important;
        padding: 1rem !important;
        display: flex !important;
        margin: 0 !important;
        justify-content: flex-start !important;
        flex-direction: column !important;
        flex: 1 !important;
    }

     .advantage-item {
         text-align: left;
         padding: 0;
         background: transparent;
         border-radius: 0;
         box-shadow: none;
         margin-bottom: 0;
     }

     .advantage-icon-content {
         display: flex;
         flex-direction: row;
         align-items: center;
         gap: 0.75rem;
         justify-content: flex-start;
         margin-top: 0 !important;
     }

    .advantage-icon-img {
        width: 40px;
        height: 40px;
        object-fit: contain;
        flex-shrink: 0;
    }

    .advantage-icon-title {
        font-size: 1rem;
        font-weight: bold;
        text-align: left;
        line-height: 1.3;
        flex: 1;
    }

     .advantage-icon-text {
         /* display: none; */
     }

     .advantage-icon {
         width: 6rem;
         height: 6rem;
         margin: 0 auto 1rem;
     }

     .advantage-title {
         font-size: 1.5rem;
         margin-bottom: 0.5rem;
     }

     .advantage-description {
         font-size: 14px;
         line-height: 1.4;
     }

     /* 新闻section适配 */
     .news-grid {
         grid-template-columns: 1fr;
         gap: 1.5rem;
         padding: 0 1rem;
     }

     .news-item {
         text-align: center;
     }

     .news-image {
         width: 100%;
         height: 200px;
         margin-bottom: 1rem;
     }

    .news-title {
        font-size: 1rem;
        margin-bottom: 0.5rem;
        line-height: 1.3;
    }

    .news-date {
        font-size: 0.8rem;
    }

     /* 全球地图section适配 */
     .global-map {
         width: 100%;
         height: auto;
         margin: 1rem 0;
     }

     /* 公司介绍section适配 */
     .company-intro {
         margin: 0 auto;
         width: 100%;
         max-width: 40rem;
         text-align: center;
         padding: 0 1rem;
     }

    .company-intro p {
        font-size: 1rem;
        line-height: 1.6;
        margin-bottom: 1rem;
    }

     /* 核心优势section适配 */
     .core-advantages {
         padding: 0 1rem;
     }

    .core-advantages .section-subtitle {
        font-size: 0.9rem;
        line-height: 1.6;
        text-align: center;
    }
    .core-advantages .flow-subtitle {
        font-size: 0.9rem;
        line-height: 1.6;
        text-align: left;
    }

    
    

    /* 按钮适配 */
    .btn-default,
    .btn-primary-1 {
        width: 100% !important;
        max-width: 280px !important;
        margin: 0 auto !important;
        display: block !important;
        text-align: center !important;
        height: 45px !important;
        line-height: 45px !important;
        font-size: 1rem !important;
        border-radius: 4px !important;
        margin-top: 0 !important;
    }

     /* Footer适配 */
     .footer {
         padding: 2rem 1rem 0 1rem;
     }

     .footer-content {
         display: flex;
         flex-direction: column;
         align-items: center;
         text-align: center;
         gap: 2rem;
     }

     .footer-divider {
         display: block !important;
         width: 100%;
         max-width: 19.1rem;
         height: 1px;
         background-color: rgba(255, 255, 255, 0.3);
         margin: 1rem 0;
     }

     .footer-nav {
         display: flex !important;
         flex-direction: column;
         gap: 1.1rem;
         width: 100%;
         max-width: 19.1rem;
         align-items: flex-start;
         text-align: left;
     }

     .footer-nav a {
         text-align: left !important;
         margin-bottom: 0.3rem;
         font-size: 1.1rem;
         font-weight: normal;
        color: #ffffff;
        opacity: 0.6;
     }

     .footer-group a:first-child {
        font-size: 1.1rem;
        font-weight: 500;
        opacity: 1;
     }

     .footer-content>div:last-child {
         display: none !important;
     }

     .footer-logo {
         display: flex;
         justify-content: center;
         margin-bottom: 0;
     }


     .social-icons {
         display: flex;
         justify-content: center;
         gap: 1rem;
         margin: 1rem 0 0 0;
     }

    .social-icon {
        width: 3rem;
        height: 3rem;
    }

    .footer-email {
        font-size: 1rem;
        color: #FFFFFF;
        text-align: center;
        margin: 1rem 0 0 0;
    }

 .footer-divider {
     display: none;
 }

    .copyright {
        text-align: center;
        border-top: 1px solid rgba(255, 255, 255, 0.3) !important;
        margin: 1rem 0 !important;
        padding-top: 1rem !important;
        padding-bottom: 0 !important;
        color: #999;
    }

    /* 表格适配 */
    .delivery-table {
        width: 100%;
        font-size: 0.9rem;
        margin-bottom: 1rem;
    }

     .delivery-table td {
         padding: 0.5rem;
     }

    /* Tab按钮适配 */
    .tab-button {
        font-size: 1rem;
    }

     /* 防止水平滚动 */
     .image-grid-container {
         overflow: hidden;
     }

     .carousel-container {
         overflow: hidden;
     }

     .platform-logos {
         overflow: hidden;
     }

     .footer-left-content {
        margin:  0 auto;
     }
     .footer-logo {
        margin: 0 auto;
     }
     .contact-us {
        font-size: 1.1rem;
        font-weight: normal;
        color: #FFFFFF;
        text-align: center;
        opacity: 0.8;
     }
     .footer-logo-img {
        width: 19.1rem;
        height: 5.75rem;
     }
     .footer-group {
        margin-bottom: 3.2rem;
     }

    /* 确保所有元素不超出屏幕宽度 */
    .section,
    .container,
    .container-2 {
        max-width: 100%;
        overflow-x: hidden;
    }
    .footer-content-icon-content {
        display: flex;
        align-items: flex-start;
    }

    html[lang="cn"] .hero-content span {
        font-size: 1.7rem;
        text-align: center;
    }
    /* English language specific styling for mobile */
   .hero-content span {
        font-size: 1.5rem;
        text-align: center;
        margin-bottom: 0.5rem;
    }

    .hero-content p {
        font-size: 0.8rem;
        text-align: center;
        margin: 1rem auto 2rem;
        width: 90%;
    word-break: break-all;
    }

    html[lang="cn"] .hero-content p {
        font-size: 0.8rem;
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 2rem;
    }

    .hero-title2 {
        font-size: 1.3rem;
        text-align: center;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }


    html[lang="en"] .section-title {
        font-size: 1.3rem;
    }

    html[lang="en"] .section-subtitle {
        font-size: 0.9rem;
    }

    html[lang="en"] .platform-section-title {
        font-size: 1.3rem;
    }

    html[lang="en"] .platform-section-subtitle {
        font-size: 0.9rem;
        margin-bottom: 1.5rem;
    }

    /* 英文版特殊布局调整 - 调整platform-logos位置避免重叠 */
    html[lang="en"] .platform-content > div:first-child > div:first-child {
        margin-bottom: 6rem;
    }

    html[lang="en"] .platform-content > div:first-child > div:last-child {
        margin-top: 6rem;
    }

    /* 英文版调整platform-logos位置 */
    html[lang="en"] .platform-content .platform-logos {
        top: 55%;
    }

    html[lang="en"] .delivery-title {
        font-size: 1.3rem;
    }

    html[lang="en"] .delivery-title-success {
        font-size: 1.3rem;
    }

    html[lang="en"] .step-title-text {
        font-size: 1.2rem;
    }

    html[lang="en"] .advantage-icon-title {
        font-size: 0.9rem;
    }

    html[lang="en"] .cta-title-text {
        font-size: 1.3rem;
    }

    html[lang="en"] .cta-right-content-item {
        font-size: 0.8rem;
    }

    html[lang="en"] .news-title {
        font-size: 0.9rem;
    }

    html[lang="en"] .company-intro p {
        font-size: 0.9rem;
    }

    html[lang="en"] .core-advantages .section-subtitle {
        font-size: 0.9rem;
    }

    html[lang="en"] .tab-button {
        font-size: 1.2rem;
    }

    html[lang="en"] .delivery-table {
        font-size: 0.8rem;
    }
    html[lang="en"]  .platform-buttons {
         flex-direction: column;
         gap: 1rem;
         align-items: center;
     }

    
}

/* 修改轮播样式为正方形 */
.product-carousel-container {
  position: relative;
  width: 100%;
  margin: 3rem 0;
  padding: 0 2rem;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-bottom: 2rem;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
  will-change: transform;
  align-items: center;
}

.carousel-item {
  flex: 0 0 20%; /* 默认5张图片，每张20%宽度 */
  padding: 0 10px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.carousel-item.active {
  transform: scale(1.2);
  z-index: 2;
}

.carousel-item.left {
  transform: scale(0.9) translateX(-10px);
  opacity: 0.8;
}

.carousel-item.right {
  transform: scale(0.9) translateX(10px);
  opacity: 0.8;
}

/* 新增：图片包装器确保正方形 */
.carousel-image-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.carousel-image-wrapper::before {
  content: '';
  display: block;
  padding-top: 100%; /* 1:1 宽高比，确保正方形 */
}

.carousel-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; /* 保持图片比例，填充整个正方形 */
  border-radius: 10px;
  box-shadow: 0 4px 5px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.carousel-item.active .carousel-image {
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  transform: scale(1.05);
}

.carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background: rgba(100, 184, 0, 0.9);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.carousel-nav:hover {
  background: rgba(100, 184, 0, 1);
  transform: translateY(-50%) scale(1.1);
}

.carousel-prev {
  left: 2px;
}

.carousel-next {
  right: 2px;
}

/* 指示点样式 */
.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 25px;
  flex-wrap: wrap;
  max-width: 100%;
  padding: 0 10px;
}

.indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ddd;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.indicator.active {
  background-color: #64B800;
  transform: scale(1.2);
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .carousel-item {
    flex: 0 0 25%; /* 平板端显示4张图片 */
  }
  
  .carousel-nav {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
  
  .carousel-indicators {
    gap: 6px;
  }
  
  .indicator {
    width: 8px;
    height: 8px;
  }
}

@media (max-width: 768px) {
  .product-carousel-container {
    padding: 0 1rem;
  }
  
  .carousel-item {
    flex: 0 0 33.33%; /* 手机端显示3张图片 */
  }
  
  .carousel-nav {
    width: 35px;
    height: 35px;
    font-size: 18px;
  }
  
  .carousel-prev {
    left: 5px;
  }
  
  .carousel-next {
    right: 5px;
  }
  
  .carousel-indicators {
    gap: 5px;
    padding: 0 5px;
  }
  
  .indicator {
    width: 7px;
    height: 7px;
  }
}

@media (max-width: 480px) {
  .carousel-item {
    flex: 0 0 33.33%; /* 小手机端保持3张图片 */
  }
  
  .carousel-indicators {
    gap: 4px;
  }
  
  .indicator {
    width: 6px;
    height: 6px;
  }
}

/* 悬停暂停功能 */
.carousel-wrapper:hover .carousel-nav {
  opacity: 1;
}

/* 确保轮播容器在移动端有良好的触摸体验 */
.carousel-track {
  -webkit-overflow-scrolling: touch;
}

/* 图片加载时的过渡效果 */
.carousel-image {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* 确保所有图片容器高度一致 */
.carousel-item {
  height: auto;
  min-height: 0;
}

</style>
